// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-service-page',
    // #endregion
    // #region Data
    data: () => ({}),
    // #endregion
    // #region Constructor
    created() {
        this.loadData();
    },
    // #endregion
    // #region Computed
    computed: {
        serviceMenu() {
            return this.$host.store.getter("navigation/getMenu", "SERVICE");
        },
    },
    // #endregion
    // #region Core
    methods: {
        loadData() {
        },
        OnRefresh(event) {
            //Default
            event.preventDefault();
            //Notify
            this.$host.eventBus.emit('refresh');
        }
    },
    // #endregion
});
// #endregion
